import { render } from "./BaseToggleSwitch.vue?vue&type=template&id=739540f3&scoped=true"
import script from "./BaseToggleSwitch.vue?vue&type=script&lang=js"
export * from "./BaseToggleSwitch.vue?vue&type=script&lang=js"

import "./BaseToggleSwitch.vue?vue&type=style&index=0&id=739540f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739540f3"]])

export default __exports__